import {Box, Grid, Typography, Tooltip, ToggleButtonGroup, ToggleButton, IconButton} from "@mui/material";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ViewListIcon from '@mui/icons-material/ViewList';
import DownloadIcon from '@mui/icons-material/Download';
import CalenderDay from "../componenets/CalenderDay";
import CalenderListView from "../componenets/CalenderListView";
import {useEffect, useState} from "react";
import {getCalender, getCalenderNextDays} from "../services/CalenderService";
import {useNavigate} from "react-router-dom";

const CalenderPage = ({company}) => {
  const navigate = useNavigate();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [calenderData, setCalenderData] = useState([]);
  const [viewMode, setViewMode] = useState("calendar"); // "calendar" or "list"

  const daysInMonth = (month, year) => {
    return new Date(year, month, 0).getDate();
  }

  // Add this function
  const handleFeedRedirect = (feedId) => {
    navigate(`/app/feed/${feedId}`); // Updated route
  };

  useEffect(() => {
    let numberOfDaysInMonth = daysInMonth(currentDate.getMonth(), currentDate.getFullYear());
    let fromDate = new Date(currentDate);
    let toDate = new Date(currentDate);

    getCalender(company.id, Date.parse(new Date(fromDate.setDate(-10))), Date.parse(new Date(toDate.setDate(numberOfDaysInMonth + 10))))
        .then(res => {
          setCalenderData(res.data);
        });
  }, [currentDate]);

  const handleViewChange = (event, newView) => {
    if (newView !== null) {
      setViewMode(newView);
    }
  };

  const getDayOfYear = (date) => {
    const start = new Date(date.getFullYear(), 0, 0);
    const diff = (date - start) + ((start.getTimezoneOffset() - date.getTimezoneOffset()) * 60 * 1000);
    const oneDay = 1000 * 60 * 60 * 24;
    return Math.floor(diff / oneDay);
  };

  const getDateFromDayOfYear = (dayOfYear, year) => {
    const date = new Date(year, 0);
    date.setDate(dayOfYear);
    return date;
  };

  const FeatureType = {
    NEWS: "News",
    WEEKLY_DIGEST: "Weekly Digest",
    NEWS_GENERAL: "News General",
    NEWS_FINANCE: "News Finance",
    SINGLE_POST: "Single Post",
    ARTICLE: "Article",
    BRANDING_BANNER: "Branding Banner",
    SEO: "SEO"
  };

  const handleDownloadCSV = async () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Fetch data for the next 70 days
    const response = await getCalenderNextDays(company.id);
    const downloadData = response.data || [];

    // Sort the data
    const sortedData = downloadData.sort((a, b) => {
      const dateA = getDateFromDayOfYear(a.dayOfYear, a.year || today.getFullYear());
      const dateB = getDateFromDayOfYear(b.dayOfYear, b.year || today.getFullYear());
      if (dateA.getTime() !== dateB.getTime()) return dateA - dateB;
      return (a.hourOfDay || 0) - (b.hourOfDay || 0);
    });

    // CSV header
    const headers = ["Date", "Day", "Time", "Feature Type", "Format", "Title", "Status"];

    // CSV rows
    const rows = sortedData.map(item => {
      const itemDate = getDateFromDayOfYear(item.dayOfYear, item.year || today.getFullYear());
      const dateStr = itemDate.toISOString().split('T')[0];
      const dayStr = itemDate.toLocaleString("en-US", {weekday: "long"});
      const timeStr = item.hourOfDay !== undefined ? `${item.hourOfDay}:00` : "";
      const featureType = FeatureType[item.featureType] || item.featureType || "";
      const formatName = (item.formatName || "").replace(/"/g, '""');
      const title = (item.title || "").replace(/"/g, '""'); // Escape quotes
      const status = item.calenderStatus || "";

      return `"${dateStr}","${dayStr}","${timeStr}","${featureType}","${formatName}","${title}","${status}"`;
    });

    // Combine header and rows
    const csvContent = [headers.join(","), ...rows].join("\n");

    // Create and download file
    const blob = new Blob([csvContent], {type: "text/csv;charset=utf-8;"});
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    const todayStr = today.toISOString().split('T')[0];
    link.href = url;
    link.download = `calendar-${company.name || company.id}-next-70-days-${todayStr}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
      <>
        {currentDate &&
            <>
              <Box sx={{display: "flex", justifyContent: "center", alignItems: "center", mt: "28px", mb: "28px", position: "relative"}}>
                {/* View Toggle & Download - Top Right */}
                <Box sx={{position: "absolute", right: 20, top: 0, display: "flex", alignItems: "center", gap: 1}}>
                  <ToggleButtonGroup
                    value={viewMode}
                    exclusive
                    onChange={handleViewChange}
                    size="small"
                  >
                    <ToggleButton value="calendar">
                      <Tooltip title="Calendar View">
                        <CalendarMonthIcon sx={{fontSize: "20px"}}/>
                      </Tooltip>
                    </ToggleButton>
                    <ToggleButton value="list">
                      <Tooltip title="List View">
                        <ViewListIcon sx={{fontSize: "20px"}}/>
                      </Tooltip>
                    </ToggleButton>
                  </ToggleButtonGroup>
                  <Tooltip title="Download CSV">
                    <IconButton onClick={handleDownloadCSV} size="small">
                      <DownloadIcon sx={{fontSize: "20px"}}/>
                    </IconButton>
                  </Tooltip>
                </Box>

                {/* Month Navigation */}
                <KeyboardArrowLeftIcon
                    onClick={() => setCurrentDate(prv => {
                      return new Date(prv.getFullYear(), prv.getMonth() - 1);
                    })}
                    sx={{width: "30px", cursor: "pointer", height: "30px", "&:hover": {
                        backgroundColor: "rgba(52,68,52,0.1)", borderRadius: "24px"}}}/>
                <Typography sx={{fontSize: "20px", mr: "20px", ml: "20px"}}>
                  {currentDate.toLocaleString("en-US", { month: "long", year: "numeric"})}
                </Typography>
                <KeyboardArrowRightIcon
                    onClick={() => setCurrentDate(prv => {
                      return new Date(prv.getFullYear(), prv.getMonth() + 1);
                    })}
                    sx={{width: "30px", cursor: "pointer", height: "30px", "&:hover": {
                        backgroundColor: "rgba(52,68,52,0.1)", borderRadius: "24px"}}}/>
              </Box>

              {/* Calendar View */}
              {viewMode === "calendar" && (
                <Grid sx={{mt: "10px"}} container spacing={0} columns={14}>
                  {Array.from(Array(35), (_, i) => {
                    return (
                        <CalenderDay
                            key={i}
                            calenderData={calenderData}
                            date={new Date(currentDate.getFullYear(), currentDate.getMonth(), i+1)}
                            onFeedRedirect={handleFeedRedirect}
                        />
                    );
                  })}
                </Grid>
              )}

              {/* List View */}
              {viewMode === "list" && (
                <CalenderListView
                  calenderData={calenderData}
                  currentDate={currentDate}
                  onFeedRedirect={handleFeedRedirect}
                />
              )}
            </>
        }
      </>
  )
};

export default CalenderPage;
